<template>
  <div>
    <template v-for="duties in dutiesByMonth">
      <v-card-title :key="duties.yearMonth">{{ getMonthTitle(duties.yearMonth) }}</v-card-title>
      <div :key="duties.yearMonth + '_'">
        <div v-for="(duty, index) in duties.listOfDuties" :key="index">
          <duty-list-item :duty="duty"></duty-list-item>
          <v-divider></v-divider>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import DutyListItem from '@/modules/myDuties/components/DutyListItem.vue';
import dutiesUtil from "@/modules/myDuties/common/dutiesUtil";

export default {
  components: { DutyListItem },
  props: {
    dutiesByMonth: Array,
  },
  methods: {
    /**
     * Year and month in String form ${year}_${month_zero_based}
     * @param yearMonth
     * @returns {string}
     */
    getMonthTitle(yearMonth) {
      return dutiesUtil.getMonthTitle(yearMonth, this.locale);
    },
  },
};
</script>
